import React, { Component } from "react";
import { Row, Col, InputGroup, Card } from "reactstrap";
import "./Receipt.scss";
class MobileReceipt extends Component {
    constructor() {
      super();
      this.state = {
        OrderId: "",
        orderDetailsData: [],
        orderDetails: [],
        TaxAmount: 0,
      };
    }
  
    componentDidMount = async () => {
      
    let data=[]
    
    }
  
  
   
  
    render() {
      return (
        <>
        <div className="mainreceipt">
         
            <div className="hdr" style={{borderBottom:"1px"}}>Boat Booking -Ticket</div>
            <hr/>
            <div>
<span className="dateTime">24/06/2021  7:30PM</span>
</div>
<div>
<span className="title">TEST BOAT HOUSE</span>
<Row>
<span className="details">Booking Type:Normal</span>
</Row>
<Row>
<span className="details1">Booking Id:71</span>
</Row>
<Row>
<span className="details2">Online Payment</span>
</Row>
<Row>
<span className="details2">9874563210</span>
</Row>
<hr/>
<span className="title">Boat Receipt-71</span>

<Row>
  <Col>  <span   className="sub1" style={{marginLeft:"5px",fontWeight:"500"}}>Payment Type</span></Col>
  <Col style={{textAlign:"end"}}>  <span  className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>Online</span></Col>
</Row>
<Row>
  <Col>  <span className="sub1"  style={{marginLeft:"5px",fontWeight:"500"}}>Boat Charge</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>750.00</span></Col>
</Row>
<Row>
  <Col>  <span  className="sub1" style={{marginLeft:"5px",fontWeight:"500"}}>Rower Charge</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>50.00</span></Col>
</Row>
<Row>
  <Col>  <span  className="sub1" style={{marginLeft:"5px",fontWeight:"500"}}>Online Service</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>10.00</span></Col>
</Row>
<Row>
  <Col>  <span className="sub1" style={{marginLeft:"5px",fontWeight:"500"}}>Deposit Amount</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>0</span></Col>
</Row>
<Row>
  <Col>  <span className="sub1" style={{marginLeft:"5px",fontWeight:"500"}}>Tax Amount</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500"}}>10.00</span></Col>
</Row>
<hr/>
<Row>
  <Col>  <span  className="sub1" style={{marginLeft:"5px",fontWeight:"500",fontSize:"18px"}}>Total</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500",fontSize:"18px"}}>820.00</span></Col>
</Row>
<Row>
  <Col>  <span className="sub1" style={{marginLeft:"5px",fontWeight:"500",fontSize:"18px"}}>Discount</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500",fontSize:"18px"}}>0.00</span></Col>
</Row>
<Row>
  <Col>  <span className="sub1" style={{marginLeft:"5px",fontWeight:"500",fontSize:"18px"}}>Net Amount</span></Col>
  <Col style={{textAlign:"end"}}>  <span className="sub2" style={{marginLeft:"55px",fontWeight:"500",fontSize:"18px"}}>₹820.00</span></Col>
</Row>
<hr/>
<Row><span className="gst">GSTIN-123456</span></Row>
<Row><span className="details2">Instructions:</span></Row>
<Row><span className="inst">•Life Jackets is mandatory while riding in boats</span></Row>
<Row><span className="inst">•Stay Safe and Distance</span></Row>
<Row><span className="inst">•Please ensure that ur tickets are scanned</span></Row>
            </div>
           
        </div>
        </>
      );
    }
  }
  
  export default MobileReceipt;
  